import { render, staticRenderFns } from "./preview-popup.component.vue?vue&type=template&id=71de1428&"
import script from "./preview-popup.component.ts?vue&type=script&lang=ts&"
export * from "./preview-popup.component.ts?vue&type=script&lang=ts&"
import style0 from "./preview-popup.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports